import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';

import { AppState } from '../../app/store/store.types';

export const PageTitle = () => {
    const { strandName } = useSelector<AppState, AppState['activityState']>(state => state.activityState);

    return (
        <Helmet>
            <title>{`${strandName ? strandName + ' - ' : ''}New Courses - Mathletics`}</title>
        </Helmet>
    );
};
